export var menuItems={
  "data": [
    {

      "type": "headtitle"
    },
    
    
    {
      "path": "/",
      "title": "หน้าแรก",
      "title_en":"Home",
      "icon": "stroke-home",
      "iconf":"fill-home",
      "type": "link",
      "active":false
    },
    {
      "path": "/find-order",
      "title": "ค้นหาคำสั่งซื้อ",
      "title_en":"Find order",
      "icon": "stroke-search",
      "iconf":"fill-search",
      "type": "link",
      "active":false
    },
    {
      "path": "https://www.facebook.com/sportactionteam",
      "title": "ผลงานของเรา",
      "title_en":"My Profile",
      "icon": "stroke-social",
      "iconf":"fill-faq",
      "type": "extLink",
      "active":false
    },
    {
      "path": "https://my.sportaction.photos",
      "title": "ช่างภาพ",
      "title_en":"Photographer",
      "icon": "stroke-camera-minimal",
      "iconf":"fill-camera",
      "type": "extLink",
      "active":false
    }
  ]
}